import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import TrendingDownOutlinedIcon from "@mui/icons-material/TrendingDownOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";

const fmtNum = (v) =>
  v == null
    ? "—"
    : Number(v).toLocaleString("es-ES", { maximumFractionDigits: 2 });

const Metric = ({ icon, label, value, color, accent }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Box
      sx={{
        flex: "1 1 180px",
        minWidth: 180,
        p: 1.5,
        borderRadius: 2,
        border: "1px solid",
        borderColor: alpha(accent, 0.32),
        backgroundColor: isDark
          ? alpha(accent, 0.1)
          : alpha(accent, 0.06),
        boxShadow: `0 4px 12px ${alpha(theme.palette.common.black, isDark ? 0.3 : 0.05)}`,
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Box
          sx={{
            width: 28,
            height: 28,
            borderRadius: "50%",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            color: accent,
            backgroundColor: alpha(accent, 0.18),
            border: "1px solid",
            borderColor: alpha(accent, 0.35),
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>
        <Typography
          variant="caption"
          sx={{
            fontWeight: 700,
            letterSpacing: 0.4,
            textTransform: "uppercase",
            opacity: 0.85,
          }}
        >
          {label}
        </Typography>
      </Stack>
      <Typography
        sx={{
          fontWeight: 800,
          fontSize: "1.05rem",
          color,
          textAlign: "right",
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};

const TablaReducidaVista = ({ m }) => {
  const theme = useTheme();

  const isAbierto =
    (m.SITUACION || "").trim().toUpperCase() !== "S" ||
    (m.ESTADO || "").trim().toUpperCase() === "A";

  const margen = (() => {
    const pedido = m.PedidoCompraE ?? 0;
    const venta = m.VentaBaseEUR ?? 0;
    const invCost = m.InvCostMoneda ?? 0;
    const invSales = m.InvSalesMoneda ?? 0;
    if ((m.SITUACION || "").trim().toUpperCase() === "S") {
      return invSales + invCost;
    }
    return venta + pedido;
  })();

  const margenColor = isAbierto
    ? theme.palette.info.main
    : theme.palette.success.main;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1.25,
        alignItems: "stretch",
      }}
    >
      <Metric
        icon={<ShoppingCartOutlinedIcon fontSize="small" />}
        label="P. Compra"
        value={fmtNum(m.PedidoCompraE)}
        color={theme.palette.error.main}
        accent={theme.palette.error.main}
      />
      <Metric
        icon={<StorefrontOutlinedIcon fontSize="small" />}
        label="P. Venta"
        value={fmtNum(m.VentaBaseEUR)}
        color={theme.palette.info.main}
        accent={theme.palette.info.main}
      />
      <Metric
        icon={<TrendingDownOutlinedIcon fontSize="small" />}
        label="F. Compra"
        value={fmtNum(m.InvCostMoneda)}
        color={theme.palette.error.main}
        accent={theme.palette.error.main}
      />
      <Metric
        icon={<TrendingUpOutlinedIcon fontSize="small" />}
        label="F. Venta"
        value={fmtNum(m.InvSalesMoneda)}
        color={theme.palette.success.main}
        accent={theme.palette.success.main}
      />
      <Metric
        icon={<PaidOutlinedIcon fontSize="small" />}
        label="Margen"
        value={Number(margen).toLocaleString("es-ES", {
          maximumFractionDigits: 2,
        })}
        color={margenColor}
        accent={margenColor}
      />
    </Box>
  );
};

export default TablaReducidaVista;
